import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';

const HOST = process.env.REACT_APP_API_HOST;
const WEBSOCKET_URL = `${HOST}/api/ws`;
const TOPICS_PATH = '/topic/';

let stompClient = null;
let onConnectCallbacks = [];
let isConnected = false;

const connect = (token, onConnect) => {
    const urlWithToken = WEBSOCKET_URL + '?token=' + encodeURIComponent(token);
    stompClient = new Client({
        brokerURL: urlWithToken,
        webSocketFactory: () => new SockJS(urlWithToken),
        onConnect: frame => {
            isConnected = true;
            try {
                // drain queued subscriptions
                onConnectCallbacks.forEach(fn => {
                    try { fn(); } catch (e) { /* no-op */ }
                });
            } finally {
                onConnectCallbacks = [];
            }
            if (typeof onConnect === 'function') {
                onConnect(frame);
            }
        },
        onStompError: frame => {
            const errorMessage = frame.headers['message'];
            console.error('WebSocket error:', errorMessage);
            console.error('Additional details:', frame.body);
            
            // Handle specific error types
            if (errorMessage && errorMessage.includes('AccessDeniedException')) {
                console.warn('WebSocket access denied - user may not have chat permissions');
            }
        }
    });
    stompClient.activate();
};


const disconnect = () => {
    if (stompClient !== null) {
        stompClient.deactivate();
    }
    isConnected = false;
};

const sendMessage = (message, destination) => {
    if (!stompClient || !stompClient.connected) {
        console.warn('WebSocket not connected, cannot send message to:', destination);
        return false;
    }
    try {
        stompClient.publish({ destination, body: JSON.stringify(message) });
        return true;
    } catch (e) {
        console.error('Failed to publish STOMP message:', e);
        return false;
    }
};

const subscribe = (topic, callback) => {
    const doSubscribe = () => {
        try {
            return stompClient.subscribe(`${TOPICS_PATH}${topic}`, message => {
                callback(JSON.parse(message.body));
            });
        } catch (error) {
            console.error('Failed to subscribe to WebSocket topic:', topic, error);
            return null;
        }
    };

    if (!stompClient || !stompClient.connected) {
        console.warn('WebSocket not connected, queueing subscription to topic:', topic);
        onConnectCallbacks.push(doSubscribe);
        return null;
    }
    return doSubscribe();
}

export const webSockets = {
    connect,
    subscribe,
    sendMessage,
    disconnect
};
